
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class EmployeeQualificationGrid extends _Ext.GridBase<EmployeeQualificationRow, any> {
        protected getColumnsKey() { return 'HR.EmployeeQualification'; }
        protected getDialogType() { return EmployeeQualificationDialog; }
        protected getIdProperty() { return EmployeeQualificationRow.idProperty; }
        protected getInsertPermission() { return EmployeeQualificationRow.insertPermission; }
        protected getLocalTextPrefix() { return EmployeeQualificationRow.localTextPrefix; }
        protected getService() { return EmployeeQualificationService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}